import React from 'react';
import { ChangeEvent, useState, FC, useCallback } from "react";
import { parseFromBin, parseFromOct, parseFromDeci, parseFromHex } from "./BaseNumHook";

export const BaseNumApp = () =>
{
	const [binText, setBinText] = useState("");
	const [octText, setOctText] = useState("");
	const [deciText, setDeciText] = useState("");
	const [hexText, setHexText] = useState("");

	const binConvert = () => {
		const pattern = new RegExp("^[01]+$", "g");
		if (binText.match(pattern))
		{
			setOctText(parseFromBin(binText, 8));
			setDeciText(parseFromBin(binText, 10));
			setHexText(parseFromBin(binText, 16));
		}
		else
		{
			window.alert("不正な2進数 (^[01]+$)");
		}
	};
	const octConvert = () => {
		const pattern = new RegExp("^[0-7]+$", "g");
		if (octText.match(pattern))
		{
			setBinText(parseFromOct(octText, 2));
			setDeciText(parseFromOct(octText, 10));
			setHexText(parseFromOct(octText, 16));
		}
		else
		{
			window.alert("不正な8進数 (^[0-7]+$)");
		}
	};
	const deciConvert = () => {
		const pattern = new RegExp("^[0-9]+$", "g");
		if (deciText.match(pattern))
		{
			setBinText(parseFromDeci(deciText, 2));
			setOctText(parseFromDeci(deciText, 8));
			setHexText(parseFromDeci(deciText, 16));
		}
		else
		{
			window.alert("不正な10進数 (^[0-9]+$)");
		}
	};
	const hexConvert = () => {
		const pattern = new RegExp("^[0-9a-fA-F]+$", "g");
		if (hexText.match(pattern))
		{
			setBinText(parseFromHex(hexText, 2));
			setOctText(parseFromHex(hexText, 8));
			setDeciText(parseFromHex(hexText, 10));
		}
		else
		{
			window.alert("不正な16進数 (^[0-9a-fA-F]+$)");
		}
	};

	return (
		<div>
			<h1>進数変換</h1>
			<table className='table'>
				<tbody>
					<tr>
						<th>2進数</th>
						<td><input className='form-control' value={binText} onChange={(e)=>setBinText(e.target.value)}/></td>
						<td><button className="btn btn-primary" onClick={binConvert}>変換</button></td>
					</tr>
					<tr>
						<th>8進数</th>
						<td><input className='form-control' value={octText} onChange={(e)=>setOctText(e.target.value)}/></td>
						<td><button className="btn btn-primary" onClick={octConvert}>変換</button></td>
					</tr>
					<tr>
						<th>10進数</th>
						<td><input className='form-control' value={deciText} onChange={(e)=>setDeciText(e.target.value)}/></td>
						<td><button className="btn btn-primary" onClick={deciConvert}>変換</button></td>
					</tr>
					<tr>
						<th>16進数</th>
						<td><input className='form-control' value={hexText} onChange={(e)=>setHexText(e.target.value)}/></td>
						<td><button className="btn btn-primary" onClick={hexConvert}>変換</button></td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};
